import { getRoute } from '@/app/core/api/routes';
import { BrandInterface, BrandUpdatePayloadInterface } from '@/app/features/brand';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ResponseInterface } from '@/app/shared/interfaces/response.interface';

@Injectable({
  providedIn: 'root',
})
export class BrandApiService {
  constructor(private http: HttpClient) {}

  loadBrand() {
    const action = getRoute('brand');

    return this.http.get<ResponseInterface<BrandInterface>>(action);
  }

  loadAdminBrand() {
    const action = getRoute('admin.brand');

    return this.http.get<ResponseInterface<BrandInterface>>(action);
  }

  updateBrand(payload: BrandUpdatePayloadInterface) {
    const action = getRoute('admin.brand');

    const formPayload = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      if (value instanceof File) {
        formPayload.append(key, value);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (typeof item === 'object' && item !== null) {
            Object.entries(item).forEach(([subKey, subValue]) => {
              formPayload.append(`${key}[${index}][${subKey}]`, subValue instanceof Blob ? subValue : String(subValue));
            });
          } else {
            formPayload.append(`${key}[${index}]`, String(item));
          }
        });
      } else if (typeof value === 'object' && value !== null) {
        Object.entries(value).forEach(([subKey, subValue]) => {
          formPayload.append(`${key}[${subKey}]`, subValue instanceof Blob ? subValue : String(subValue));
        });
      } else if (value === null) {
        formPayload.append(key, '');
      } else {
        formPayload.append(key, String(value));
      }
    });

    return this.http.post<ResponseInterface<BrandInterface>>(action, formPayload);
  }
}
